
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__trafficlight","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 3h-2v2a2 2 0 002-2zM11.5 8.5a2 2 0 002-2h-2zM11.5 12a2 2 0 002-2h-2zM4.5 5V3h-2a2 2 0 002 2zM4.5 8.5v-2h-2a2 2 0 002 2zM4.5 12v-2h-2a2 2 0 002 2zM10 2H9v-.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V2H6a1 1 0 00-1 1v10a1 1 0 001 1h4a1 1 0 001-1V3a1 1 0 00-1-1zM8 13a1.5 1.5 0 111.5-1.5A1.5 1.5 0 018 13zm0-3.5A1.5 1.5 0 119.5 8 1.5 1.5 0 018 9.5zM8 6a1.5 1.5 0 111.5-1.5A1.5 1.5 0 018 6z"}})])
          )
        }
      }
    